import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool } from '../../../../helpers/custom-prop-types';
import RegistrationLink from '../../../Ui/Registration/RegistrationLink';
const ColumnContentRegistrationButton = (props) => {
    const { isGuest } = props;
    if (isGuest) {
        return (_jsx("div", Object.assign({ className: 'custom_button' }, { children: _jsx(RegistrationLink, { className: 'button primary', text: 'Proffitに登録してコンサルを検索する' }) })));
    }
    return null;
};
ColumnContentRegistrationButton.propTypes = {
    isGuest: propBool().isRequired,
};
export default ColumnContentRegistrationButton;
